import axios from "axios";

export default class PsychologistResource{

      getAvailableDates(year,month){
            return axios.get('api/psychologist/getAvailableDates?year='+year+'&'+'month='+month)
        }

        getTimes(currentYear,currentMonth,dayOfWeek,fullDate){
            return axios.post('api/psychologist/getTimes',{currentYear,currentMonth,dayOfWeek,fullDate})
        }


        reserve(timeID,date,reason,phone_number){

            return axios.post('api/psychologist/reserve',{timeID,date,reason,phone_number})
        }


        getPsychologistData(){
            return axios.get('api/psychologist/getPsychologistData')
        }

}